import { EtapaDaAgenda, etapasDaAgenda, Responsavel } from 'pages/RealizacaoDestaque/components/AgendaDaRealizacao';
import { useTaskItemEcoa } from 'components/task-item-ecoa/useTaskItemEcoa';

export type ModeloDaAcaoEcoa = ReturnType<typeof useTaskItemEcoa>;

type ModeloDoAndamento = Pick<ModeloDaAcaoEcoa, 'managersByStep' | 'timeline' | 'activeStage' | 'capitalizeWords'>;

/**
 * Responsáveis da etapa como o `TaskItemEcoa` os mostra: antes da apreciação, o `timeline` traz a lista dos
 * possíveis (responsável original e avaliadores); depois, só quem apreciou.
 */
function responsaveisDaEtapa(gestor: any, capitalizar: (texto: string) => string): Responsavel[] {
  const pessoas: any[] = Array.isArray(gestor) ? gestor : [gestor];
  return pessoas
    .filter(pessoa => !!pessoa?.nome_guerra)
    .filter((pessoa, indice, lista) => lista.findIndex(outra => outra.chave === pessoa.chave) === indice)
    .map(pessoa => ({ nome: capitalizar(pessoa.nome_guerra), chave: pessoa.chave }));
}

/**
 * ECN-08: etapas Validação e Bonificação do cartão com os mesmos títulos, textos de status, cores e responsáveis
 * que a linha do tempo do `TaskItemEcoa` calcula (`managersByStep`, `timeline`, `activeStage`). A ECOA não tem MAD.
 */
export function etapasDaAcaoEcoa(modelo: ModeloDoAndamento): EtapaDaAgenda[] {
  const etapasDoModelo = modelo.managersByStep ?? [];
  return etapasDaAgenda(modelo).map((etapa, indice) => ({
    ...etapa,
    responsaveis: responsaveisDaEtapa(modelo.timeline(etapasDoModelo[indice])?.gestor, modelo.capitalizeWords),
  }));
}
